import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import InlineSvg from "vue-inline-svg";


const __default__ = {
  name: "NoFavoriteCard",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  shouldHideBorder: {
    type: Boolean,
    default: false,
  },
  isForLine: {
    type: Boolean,
    default: true,
  },
},
  emits: ["onClickSearch"],
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;



const favoriteTypeLabel = computed(() => (props.isForLine ? "노선" : "정류장"));

const __returned__ = { props, favoriteTypeLabel, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})